import { mailConstants } from '../constants/mail.constants';

export function mail(state = {}, action) {
  switch (action.type) {
    case mailConstants.CREATE_REQUEST:
    case mailConstants.UPDATE_REQUEST:
    case mailConstants.FETCH_REQUEST:    
    case mailConstants.GET_REQUEST:
    case mailConstants.REMOVE_REQUEST:
    case mailConstants.TEST_REQUEST:
      return {
        ...state,
        loading: true
      };    
    case mailConstants.CREATE_SUCCESS:
    case mailConstants.GET_SUCCESS:
    case mailConstants.UPDATE_SUCCESS:
    return{
      ...state,
      item: action.mailTransport,
      loading: false
    }    
    case mailConstants.TEST_SUCCESS:
    case mailConstants.TEST_FAILURE:    
    return{
      ...state,
      testResult: action.testResult,
      loading: false
    }    
    case mailConstants.FETCH_SUCCESS:      
      return {
        ...state,
        ...action.mailTransports,
        loading: false
      };
    case mailConstants.CREATE_FAILURE:
    case mailConstants.FETCH_FAILURE:
    case mailConstants.GET_FAILURE:
    case mailConstants.REMOVE_FAILURE:
    case mailConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error
      };   
    default:
      return state
  }
}
